<template>
  <div v-if="showShippingInformation" id="shipping-information-section">
    <h2 class="h5 margin-bottom-xs">
      {{ ORDER_DETAILS.shippingInfoText }}
    </h2>
    <div class="cell large-8">
      <p v-if="data.differentExchangeAddress" class="exchange-address-text margin-bottom-xs large-10">
        {{ ORDER_DETAILS.exchangeInformationMessage }}
      </p>
    </div>
    <div v-if="data.shipToRegistry" class="address-privacy gray-1-color">
      <div v-text="data.firstName + ' ' + data.lastName"></div>
      <div class="small">
        {{ ORDER_DETAILS.shippingAddressPrivacyMessage }}
      </div>
    </div>
    <div v-for="(address, i) in addresses" v-else :key="address" :class="{ 'margin-bottom-s': addresses.length > 1 && i < addresses.length - 1 }">
      <div data-fs-mask v-text="data.firstName + ' ' + data.lastName"></div>
      <div v-if="address.addressLine1" data-fs-mask v-text="address.addressLine1"></div>
      <div v-if="address.addressLine2" data-fs-mask v-text="address.addressLine2"></div>
      <div v-if="address.addressLine3" data-fs-mask v-text="address.addressLine3"></div>
      <div v-if="address.city || address.state || address.postalCode" data-fs-mask>
        {{ address.city }}
        {{ address.state }}
        {{ address.postalCode }}
      </div>
      <div v-if="data.homePhone" data-fs-mask v-text="data.homePhone"></div>
      <div v-if="data.emailAddress" class="email-address" data-fs-mask v-text="data.emailAddress"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { ORDER_DETAILS } from 'config';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const isShipToRegistry = computed(() => props.data.shipToRegistry && (props.data.firstName || props.data.lastName));
const showShippingInformation = computed(
  () => props.data && typeof props.data === 'object' && Object.keys(props.data).length && (props.data.address || isShipToRegistry.value),
);
const addresses = computed(() => (!Array.isArray(props.data.address) ? [props.data.address] : props.data.address));
</script>
<style lang="scss" scoped>
.email-address {
  word-wrap: break-word;
}
.exchange-address-text {
  color: $gray-1-color;
  word-break: break-word;
  white-space: break-spaces;
}
</style>
